<template>
  <v-sheet v-if="lifeTimeDue">
    <div class="mx-6 py-5 pb-10">
      <common ref="common" />
      <div class="d-flex">
        <h3>₹ Bill Payment</h3>
      </div>
      <div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <v-radio-group v-model="pymtMode">
            <v-radio :value="0">
              <template #label>
                  <label class="font-weight-bold" style="width: 50%;">
                    Pay Total
                  </label>
                  <label class="font-weight-bold">
                    ₹ {{ formatNumber(amountPayable) }}
                  </label>                
              </template>
            </v-radio>
            <v-radio :value="1">
              <template #label>
                <label class="font-weight-bold"  style="width: 50%;">Enter amount</label>
                <ValidationProvider
                  :rules="pymtMode ? 'required' : ''"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    type="number"
                    v-model="customPymtAmy"
                    outlined
                    class="small-text-field pl-3 pt-2"
                    :error-messages="errors"
                  >
                    <template #prepend-inner>
                      ₹
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template></v-radio
            >
          </v-radio-group>
          <v-card-subtitle style="padding-left: 25px;">
            Maximum allowed payment ₹{{formatNumber(lifeTimeDue)}}
          </v-card-subtitle>
          <v-btn
            v-if="showPayBtn"
            block
            color="success"
            class="my-3"
            @click="
              pymtMode
                ? handleSubmit(()=>proceedPayment(customPymtAmy))
                : proceedPayment(amountPayable)
            "
            large
            >Make Payment</v-btn
          >
        </ValidationObserver>

        <!-- <div v-if="enterAmtProvision" class="mt-5">
          <v-row align="center" justify="center">
            <v-col cols="6">
              <ValidationObserver>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div
                    class="d-flex flex-column justify-center align-center v-row"
                  >
                    <v-text-field
                      class="v-col-6"
                      v-model="customPymtAmy"
                      :error-messages="errors"
                      label="Amount"
                      outlined
                    >
                    </v-text-field>
                    <v-btn
                      @click="proceedPayment(customPymtAmy)"
                      class="mt-3 v-col-6"
                      block
                      color="success"
                      >Make Payment</v-btn
                    >
                  </div>
                </ValidationProvider>
              </ValidationObserver>
            </v-col>
          </v-row>
        </div> -->
      </div>
    </div>
    <v-dialog v-model="paymentProcess"  fullscreen overlay-color="white" overlay-opacity="1"  :light="true" transition="dialog-bottom-transition" >
      <v-sheet :height="actualDevHeight + 'px'">
        <v-img  src="../../../assets/Images/payment/processing.gif"> </v-img>
      </v-sheet>
    </v-dialog>
    <v-dialog v-model="paymentFailure" fullscreen overlay-color="white" overlay-opacity="1"  :light="true"  transition="dialog-bottom-transition">
      <v-sheet :height="actualDevHeight + 'px'">
        <v-img  src="../../../assets/Images/payment/failed.jpg"> </v-img>
      </v-sheet>
    </v-dialog>
    <v-dialog v-model="paymentSuccess" fullscreen overlay-color="white" overlay-opacity="1"  :light="true"  transition="dialog-bottom-transition">
      <v-sheet :height="actualDevHeight + 'px'">
        <v-img  src="../../../assets/Images/payment/successful.gif"> </v-img>
      </v-sheet>
    </v-dialog>

    <v-dialog hide-overlay transition="dialog-transition" content-class="v-dialog-rounded-xl" v-model="paymentFailureDialog">
      <v-card rounded="xl">
        <v-card-text class="text-center pt-5">
          <v-icon color="error" size="80px">mdi-close-circle</v-icon>
          <h3 class="mt-6">Unfortunately we were unable to process your payment.</h3>
        </v-card-text>
          <v-card-actions class="pa-4">
            <v-btn class="elevation-0"  rounded block color="error" @click="paymentFailureDialog = false">
              Ok
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog hide-overlay transition="dialog-transition" content-class="v-dialog-rounded-xl" v-model="paymentSuccessDialog">
      <v-card rounded="xl">
        <v-card-text class="text-center pt-5">
          <v-icon color="green" size="80px">mdi-check-circle</v-icon>
          <h3 class="mt-6">Payment completed successfully</h3>
        </v-card-text>
          <v-card-actions class="pa-4">
            <v-btn class="elevation-0" rounded block color="success" @click="paymentSuccessDialog = false" >
              Ok
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>
<script>
import { callApi } from "@/api/others";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import dayjs from "dayjs";
import common from "@/components/tools/common";
import { redirectToPaymentPage } from "@/utils/payment.js";
export default {
  components: {
    common,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    pymtMode: 0,
    customPymtAmy: null,
    upcomingDues:0,
    lifeTimeDue:0,
    showPayBtn:true,
    paymentProcess: false,
    paymentFailure: false,
    paymentSuccess: false,
    paymentFailureDialog: false,
    paymentSuccessDialog: false
  }),
  props:{
    amountPayable:Number,
    memberId:String
  },
  mounted(){
    this.getOutstandingLifeTime();
  },
  watch: {
    pymtMode(nv) {
      if (!nv) {
        this.customPymtAmy = null;
      }
    },
  },
  methods: {
    getOutstandingLifeTime() {
      this.$emit("loadingChange", true);
      let url = "/api/wesupport/TransactionDetail/getOutstanding";
      let data = {
        asOn: dayjs("2099-12-31").format("YYYY-MM-DD"),
        memberId: this.decryptMemId(),
      };
      callApi(url, "post", data)
        .then((res) => {
          this.upcomingDues = res.data.data;
          this.getTotalDue();
        })
        .catch((err) => {})
        .finally(() => {
          this.$emit("loadingChange", false);
        });
    },
    getTotalDue() {
      this.lifeTimeDue = this.upcomingDues.reduce(
        (total, curr) => total + curr.balance,
        0
      );
    },
    async proceedPayment(amt) {
     await this.checkSchemes()
     .then((response)=>{
      if(response){
        this.generateOrder(amt)
      }
     })
     .catch((err)=>{
      this.$refs.common.showSnackBar("Try again later","warning");
     })
    },
    async checkSchemes() {
     return new Promise((resolve,reject)=>{
        this.$emit("loadingChange",true);
      let url = `/api/wesupport/SchemeEnrollment/GetSchemeEnrolledListByMemberId?MemberId=${this.decryptMemId() || this.memberId}`;
      callApi(url, "get", "")
      .then((res) => {
        console.log("then",res.data.data);

          if(res.data.data.length){
            resolve(true)
          }else{
            reject(false)
          }
        })
        .catch((err) => {
          reject(false)
        })
        .finally(()=>{
          this.$emit("loadingChange",false);
        });
      })      
    },
    generateOrder(amt = 0){
      var common = this.$refs.common;
      if(this.lifeTimeDue < amt) {
        common.showSnackBar(
              "You cannot pay more than " + this.lifeTimeDue + " !! " ,
              "warning"
            );
          return;
      }
      this.$emit("loadingChange",true);
      this.showPayBtn = false;
      let url = `/api/wesupport/payment/generateOrder?memberId=${this.decryptMemId()}&amount=${amt}`;

      callApi(url, "post", "")
        .then((res) => {
          this.$emit("loadingChange",false);

          if(res.data.data.type == "razorpay"){
            redirectToPaymentPage(res.data.data)
            .then((res)=>{
              this.capture(res);
            })
          }else{
            window.open(res.data.data, "_self");
          }

          this.showPayBtn = false;
        })
        .catch((err) => {
          common.ManageResponse(err.response);
        });
    },
    capture(val){
      this.paymentProcess = true;
      let url = "/api/wesupport/payment/razorpay/capture";
      callApi(url,"post",val)
      .then((res)=>{
        if(res.data.data == "success"){
          // this.$router.push({
          //   name: "PaymentSucess",
          //   params: {
          //     id: val.orderId
          //   }
          // })
        }else{
          this.paymentFailureDialog =  res.data.data == "failure";
        }
        setTimeout(() => {
          this.paymentProcess = false;
          this.paymentFailureDialog =  res.data.data == "failure";
          this.paymentSuccessDialog =  res.data.data == "success";
        }, 2000);
      })
      .catch((err)=>{
        this.paymentProcess = false
        setTimeout(() => {
          this.paymentFailureDialog = true;
        }, 2000);
      })
    }
  },
};
</script>
<style>
.small-text-field .v-text-field__details {
  /* display: none; */
}
.small-text-field .v-input__slot {
  margin: 0;
}
/* .small-text-field .v-input__control{
    height: 30px;
} */

.small-text-field .v-input__slot {
  height: 35px !important;
  min-height: 35px !important;
}
.small-text-field .v-input__prepend-inner {
  margin: auto;
}
</style>
